import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {AuditTrackerService} from '@features/audit-tracker/services/audit-tracker.service';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-review-workflow-dialog',
  templateUrl: './review-workflow-dialog.component.html',
  styleUrls: ['./review-workflow-dialog.component.css']
})
export class ReviewWorkflowDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: any;
  flowTemplates: any[];
  data: DialogModel;
  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private service: AuditTrackerService) {
    this.inputForm = this.formBuilder.group({
      flowTemplate: ['', Validators.required],
      reference: ['', Validators.required]
    });
  }

  onOkClicked(): boolean {
    return true;
  }

  onOtherButtonClicked?(): boolean {
    const flowTemplateControl = this.inputForm.controls['flowTemplate'];
    const referenceControl = this.inputForm.controls['reference'];
    flowTemplateControl.markAsTouched();
    referenceControl.markAsTouched();

    if (flowTemplateControl.hasError('required') || referenceControl.hasError('required')) {
      return false;
    }

    this.data.input['flowTemplateId'] = flowTemplateControl.value;
    this.data.input['reference'] = referenceControl.value;

    return true;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  ngOnInit(): void {
    this.service.getFlowTemplates().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      if (res) {
        this.flowTemplates = res;
      }
    });
  }

}
